var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFemme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 26,
    viewBox: "0 0 15 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49939 9.38379C13.2058 9.38379 13.4667 15.9159 14.4222 20.3721C14.4286 20.4019 14.4325 20.4325 14.431 20.4629C14.4085 20.9358 14.0402 21.3123 13.5892 21.3125H10.8724L10.1107 25.0986C10.0637 25.332 9.85847 25.4999 9.62048 25.5H5.37927C5.14117 25.5 4.93603 25.332 4.88904 25.0986L4.12634 21.3125H1.41052C0.959419 21.3125 0.591321 20.936 0.568726 20.4629C0.567282 20.4325 0.57015 20.4019 0.576538 20.3721C1.53211 15.9161 1.79326 9.38387 7.49939 9.38379ZM7.49939 0.5C9.53705 0.5 11.1898 2.15181 11.1898 4.18945C11.1898 6.22715 9.53709 7.87891 7.49939 7.87891C5.46188 7.87869 3.80994 6.22702 3.80994 4.18945C3.81 2.15195 5.46192 0.50022 7.49939 0.5Z",
    fill: "#1D3A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFemme);
export default __webpack_public_path__ + "static/media/logoFemme.0492079a4441ed1500d1bd4a020a73bc.svg";
export { ForwardRef as ReactComponent };